import { useNavigate } from "react-router-dom";
import apolloClient from 'utils/apolloClient';
import { CREATE_IMAGE_MUTATION } from 'graphql/APICalls';
import 'styles/Helpers.css';

export function PasswordInput({showPassword, setShowPassword, password, setPassword}){
    return (
      <div className="password-input">
        <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} required/>
        <button type="button" onClick={() => setShowPassword(!showPassword)} className="password-toggle" tabIndex={-1}>
          {showPassword ? <img src="/eye-open.svg" alt="Hide password" /> : <img src="/eye-closed.svg" alt="Show password" />}
        </button>
      </div>
    )
  }



const groupStatusOrder = new Map([['uninvited', 0], ['invited', 1], ['joined', 2]]);

export function GroupsDisplay({groups, noGroupsMessage, buttonStyle}) {

    const navigate = useNavigate();
  
    return (
      <div className="groups-display">
      {
        groups === undefined ?
        <div>An error occurred while retriving groups.</div> :
        
        groups.length === 0 ?
        (noGroupsMessage || <div style={{color: 'gray'}}>(No groups)</div>) :
        
        [...groups]
          .sort((a,b)=>(groupStatusOrder.get(b.status) - groupStatusOrder.get(a.status)))
          .map(group =>
            <button
              key = {group.id}
              className = {`${buttonStyle || 'group-button-1'} ${group.status}`}
              onClick = {group.status === 'uninvited' ? null : ()=>{navigate(`/g/${group.shortId}`)}}>
                {group.name}
            </button>
            // TODO: add a tooltip for uninvited groups explaining to the user it's not one of their groups
          )
      }
      </div>
    )
};


export async function handleImageUpload(image) {

  const mimeType = image.type;
  const arrayBuffer = await image.arrayBuffer();
  const CHUNK_SIZE = 4 * 1024;
  const dataLen = arrayBuffer.byteLength;
  const paddedLength = Math.ceil(dataLen / CHUNK_SIZE) * CHUNK_SIZE;
  const paddedArray = new Uint8Array(paddedLength);
  paddedArray.set(new Uint8Array(arrayBuffer), 0);
  crypto.getRandomValues(paddedArray.subarray(dataLen));

  const key = await crypto.subtle.generateKey(
      { name: 'AES-GCM', length: 256 },
      true,
      ['encrypt', 'decrypt']
  );

  const iv = crypto.getRandomValues(new Uint8Array(12));

  const encryptedArrayBuffer = await crypto.subtle.encrypt(
      { name: 'AES-GCM', iv },
      key,
      paddedArray
  );

  const rawKey = await crypto.subtle.exportKey('raw', key);
  const base64Key = btoa(String.fromCharCode(...new Uint8Array(rawKey)));
  const base64IV  = btoa(String.fromCharCode(...iv));

  console.log('Base64 Key:', base64Key);
  console.log('Base64 IV: ', base64IV);
  console.log('Original unpadded image size:', dataLen);

  // Send GraphQL mutation using Apollo Client
  const { data } = await apolloClient.mutate({
      mutation: CREATE_IMAGE_MUTATION,
      variables: {
          encoding: 'EncryptedImageV1',
          key: base64Key,
          iv: base64IV,
          imageSize: dataLen,
          mimeType: mimeType
      }
  });

  const postData = data.createImage.postRequest;

  // Construct FormData from the presigned POST
  const formData = new FormData();
  Object.entries(postData.fields).forEach(([key, value]) => {
      formData.append(key, value);
  });
  formData.append('file', new Blob([encryptedArrayBuffer], { type: mimeType }));

  // Upload encrypted file to S3
  await fetch(postData.url, {
      method: 'POST',
      body: formData
  });

  console.log('Encrypted file uploaded to S3.');

  return data.createImage.imageId
}